<template>
	<v-row justify="center">
		<v-col 
			xl = "7"
			lg = "7"
			md = "8"
			sm = "10"
			xs = "12"
			cols = "12"
		>
	<v-card outlined>
			<v-card-title				
				class="justify-center secondary body-1 pa-1"
			>
				<v-spacer></v-spacer>

				<span v-text="$ml.get('contact_list')"></span> 
				<v-spacer></v-spacer>
				<v-btn 
					x-small
					color="primary"
					@click="show=!show"
				>
					<v-icon x-small>mdi-plus</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col 
						:md="show ? 3 : 0"
						v-show="show"
					>
						<v-card outlined>
							<v-card-title
								class="justify-center body-2 secondary pa-1"
							>
								<span v-text="$ml.get('basic_info')"></span>
							</v-card-title>
							<v-card-text>
								<v-text-field
									v-model="inf.name"
									type="text"
									:label="$ml.get('name')"
									hide-details
								></v-text-field>
								<v-text-field
									v-model.number="inf.tel"
									type="number"
									:label="$ml.get('telephone')"
									hide-details
								></v-text-field>
							</v-card-text>
							<v-divider></v-divider>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn 
									small
									color="primary"									
									@click="save"
								>
									{{ update_item ? $ml.get('update') : $ml.get('save') }}
								</v-btn>
								<v-btn
									small
									color="error"
									v-text="$ml.get('close')"
									@click="close_inf"
								></v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
					<v-col :md="show ? 9 : 12">									
						<v-data-table
							dense
						    :headers="headers"
						 	:items="list"
						    class="elevation-5"			    
						    :hide-default-footer="height < 56 ?  true : false"
						   	:options.sync="options"
						   	:server-items-length="total"
						   	:footer-props="{
						   		showFirstLastPage: true,
						   		itemsPerPageOptions: [15, 30],
						   		showCurrentPage: true
						   	}"				   	
						    :height="height+'px'"
						    fixed-header
						    item-key="index"
						>
							<template v-slot:item.actions="{ item }">
								<v-icon
							        small
							        color="primary"
							        class="mr-2"
							        @click="edit(item)"
							      >
							        mdi-pencil
							      </v-icon>
							      <v-icon
							        small
							        color="error"
							        @click="del(item)"
							      >
							        mdi-delete
							      </v-icon>
							</template>

							<template v-slot:item.createdAt = "{ item }">
								{{ $momentz(item.createdAt).format('lll') }}
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-col>
	<!-- <notics_inf
		v-if="info_to_modal"
		:info="info_to_modal"
		@confirm_message="confirm_del($event)"
		@close_snack_dialog="info_to_modal=$event"
	></notics_inf> -->
</v-row>
</template>
<script>
// import notics_inf from '@/components/notics_inf.vue'
import axios from 'axios'
	export default{
		name: 'safe_zone_contacts_list',
		components:{
			// notics_inf
		}, // components
		data: vm =>({
			inf: {},
			headers:[
				// { text: vm.$ml.get('id'), value: 'id', align: 'center' },
				{ text: vm.$ml.get('name'), value: 'name', align: 'center' },
				{ text: vm.$ml.get('telephone'), value: 'tel', align: 'center' },
				{ text: vm.$ml.get('date'), value: 'createdAt', align: 'center' },
				{ text: vm.$ml.get('actions'), value: 'actions', align: 'center' }, 
			],
			list: [],
			height: 500,
			options: {itemsPerPage: 30},
			total: 1,
			del_item: 0,
			show: false,
			update_item: '',
			info_to_modal: null,

		}), // data
		watch:{
			options: {
				handler(){
					this.get_list();
				}, deep: true, 
			}, // options
		}, // watch

		methods: {
			get_list(){
				const { page, itemsPerPage } = this.options;
				let pg=1, sw=0;
				if (itemsPerPage==15) {
					if (page % 2 == 0) {
						pg=(page/2);
						sw=2;
					}else{
						pg=parseInt(page/2)+1;
						sw=1;
					}
				}else{
					pg=page
				}
				
				const api = this.$URL + '/api/v1/contact/?page='+ pg;
				// axios.defaults.withCredentials=true;
				this.$axios.get(api).then( res => {
					let item =res.data;
					let items=item.rows;
					this.total=parseInt(item.count);
					if (itemsPerPage<=15) {
						items=items.slice((sw - 1) * itemsPerPage, sw  + itemsPerPage );
					}
					this.list=items;
					// let list_new=[];
					
					/*for(let j of items){
						if (this.render_hostname(j)) {

							list_new.push(this.info_format(j));
						}
					}*/
				}).catch( er =>{
					console.log(er, 'error get list sz_contacts')
				})
			}, // get list
			save(){
				console.log(this.update_item, 'save')
				
				if(this.update_item!==''){
					this.update(this.update_item);
				}else{
					let info_to_up=this.inf;
					let info_update={
						name: info_to_up.name,
						tel: info_to_up.tel,
					}
					const api = this.$URL + '/api/v1/contact';					
					this.$axios.post(api, info_update).then( res => {
						/*this.info_to_modal={ 
							snack: true, 
							type: false,
							color: 'success',
							info: this.$ml.get('save'),
						}*/
						this.$EventBus.$emit('notifications_modal', {
							type: 'saved'
						})
						this.show=false;
						this.get_list();	
					}).catch( er => {
						console.log(er, 'error update sz contacts');
					})
				}
			},
			update(val){
				let info_to_up=this.inf;
				let info_update={
					name: info_to_up.name,
					tel: info_to_up.tel,
				}
				const api = this.$URL + '/api/v1/contact/'+val;
				
				axios.put(api, info_update).then( res => {
					/*this.info_to_modal={ 
						snack: true, 
						type: false,
						color: 'success',
						info: this.$ml.get('updated'),
					}*/
					this.$EventBus.$emit('notifications_modal', {
							type: 'updated'
						})
					this.get_list();
					this.update_item='';
					this.inf={};
					this.show=false;
				}).catch( er => {
					console.log(er, 'error update sz contacts');
				})
			}, // update
			edit(item){
				this.show=true;
				this.update_item=item.id;
				this.inf.name=item.name;
				this.inf.tel=item.tel;

			}, // edit

			del(item){
				this.del_item=item.id;
				// this.info_to_modal={ 
				// 	dialog: true, 
				// 	type: true,
				// }
				this.$EventBus.$emit('notifications_modal', {
					type: 'confirm_delete',
					ID: 'sz_contacts'
				})
				this.$EventBus.$off('notifications_modal');
			}, // del

			confirm_del(val){
				if(val){
					this.info_to_modal=null;
					const api = this.$URL + '/api/v1/contact/'+this.del_item;
					
					this.$axios.delete(api).then( res => {
						/*this.info_to_modal={ 
							snack: true, 
							type: false,
							color: 'success',
							info: this.$ml.get('deleted'),
						}*/
						this.$EventBus.$emit('notifications_modal', {
							type: 'deleted'
						})
						this.get_list();
					}).catch ( er => {
						console.log(er, 'error delete item sz contacts')
					})
				}
			}, // confirm del

			close_inf(){
				if (this.show) {
					if(this.inf){
						this.inf={};
					}
					this.update_item='';
					this.show=false;
				}
			}, // close_inf

		}, // methods

		mounted(){
			this.$EventBus.$on('notifications_modal' + 'sz_contacts', (action) => {
				if (action) {
					this.confirm_del(action);
					this.$EventBus.$off('notifications_modal' + 'sz_contacts');
				}
			})
		}, // mounted
	};
</script>